const userLibraryState = {
  showTrash: false,
  directoryView: 'grid', // Or list
  currentDirectory: {
    id: '',
    name: '',
    path: '',
    type: 'businesses',
    link: '',
    directoryData: []
  },
  selectedItems: [],
  trashItems: [],
  moveDirectory: null,
  sortQuery: null,
  moveToPath: null,
  trash: false,
  search: '',
  confirmDelete: false,
  confirmRestore: false,
  filters: ['audio', 'images', 'videos']
}

export default userLibraryState
